enum MultiAppAuthenticationViewMode {
	Company = 'company',
	Creation = 'creation',
	Login = 'login',
	Password = 'password',
	Method = 'method',
	OrgLogin = 'orgLogin'
}

enum Server {
	MIGRATIONV3 = 'MIGRATIONV3',
	FR = 'FR',
	AU = 'AU',
	AR = 'AR',
}

interface ServersData {
	[key: string]: {
		name: string;
		url: string;
		driveUrl: string;
		actions: {};
	};
}

interface AuthMethodsData {
	[key: string]: {
		text: string;
	};
}

enum AuthMethod {
	Webpublication = 'MANAGER_USERS',
	Saml = 'SAML',
	Salesforce = 'SALESFORCE',
}

const AUTH_METHODS: AuthMethodsData = {
	[AuthMethod.Webpublication]: {
		text: 'messages.webpublication'
	},
	[AuthMethod.Saml]: {
		text: 'messages.your_company_account'
	},
	[AuthMethod.Salesforce]: {
		text: 'messages.salesforce'
	},
};

const ASP_SERVERS: ServersData = {
	[Server.MIGRATIONV3]: {
		name: 'Migration',
		url: 'https://migrationv3.zone-secure.net/',
		driveUrl: 'https://migrationv3.zone-secure.net/drive/',
		actions: {}
	},
	[Server.FR]: {
		name: 'France',
		url: 'https://fr.adminzone-secure.net/',
		driveUrl: 'https://app.uprez.fr/',
		actions: {}
	},
	[Server.AU]: {
		name: 'Australia',
		url: 'https://v3au.zone-secure.net/',
		driveUrl: 'https://v3au.zone-secure.net/drive/',
		actions: {}
	},
	[Server.AR]: {
		name: 'Argentina',
		url: 'https://ar-admin.zone-secure.net/',
		driveUrl: 'https://v3ar.zone-secure.net/',
		actions: {}
	},
};

export { Server, ServersData, ASP_SERVERS, AuthMethod, AUTH_METHODS, MultiAppAuthenticationViewMode };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/constants.ts